module.exports = "\n \n<app-homeheader></app-homeheader>\n\n<router-outlet></router-outlet>\n<app-homefooter></app-homefooter> "